import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";

import QuestionPage from "../QuestionPage/QuestionPage";
import ResultPage from "../ResultPage/ResultPage";
import {addToHistory, historyBack} from "../../../store/slices/productFinder";
import BackButton from "../BackButton/BackButton";


const PageSwitch = (props) => {

    const [pageData, setPageData] = useState(props.pageData);

    const dispatch = useDispatch();

    const onBackButtonClick = (_pageData) => {
        setPageData(_pageData);
        dispatch(historyBack());
    }

    const onOptionClick = (_pageData) => {
        setPageData(_pageData);
        dispatch(addToHistory(_pageData));
    }

    if(!pageData) {
        return null;
    }

    useEffect(() => {
        dispatch(addToHistory(props.pageData));
    }, [props.pageData]);

    if(pageData.redirect) {
        document.location.href = pageData.redirect;
        return null;
    }

    return (
        <>
            <BackButton
                onClick={onBackButtonClick}
            />

            { (pageData.question && pageData.question !== '')
                ?
                    <QuestionPage pageData={pageData} onOptionClick={onOptionClick} />
                :
                    <>
                        { pageData.results && <ResultPage pageData={pageData} /> }
                    </>
            }
        </>
    )

}

export default PageSwitch;
